import {Chart} from 'chart.js';
import {TimeSeriesDataArray} from '../../interfaces/time-series-data';
import {time} from '../../services/global-variables.service';
import {enUS} from 'date-fns/locale';
import {registerables} from 'chart.js';
import 'chartjs-adapter-date-fns';
import zoomPlugin from 'chartjs-plugin-zoom';
import {TimeSeriesData, TimeSeriesDataItem} from '../../interfaces/data-analytics';

export class ChartJsMotion {

  graph: Chart;

  getBackgroundColour(elementName: string) {
    switch (elementName) {
      case 'movement':
        return '#0E8E75';
      case 'lightLevel':
        return 'orange';
    }
  }

  public draw(data: TimeSeriesDataArray[], features) {

    Chart.register(...registerables);
    Chart.register(zoomPlugin);

    motionDataProcess(data, features);

    let graphDataSets = [];

    for (let i = features.length - 1; i > 0; i--) {
      let element = features[i];
      if (!element) {
        continue;
      }
      let dataSet = data[i];
      let processedData = [];
      for (let i in dataSet) {
        processedData.push({
          x: dataSet[i].timestamp,
          y: dataSet[i].value
        });
      }
      let graphDataSet = {
        label: element.attributes.type,
        data: processedData,
        pointRadius: 0,
        borderWidth: 1,
        stepped: element.attributes.type === 'movement' ? 'after' : false,
        yAxisID: element.attributes.type,
        backgroundColor: this.getBackgroundColour(element.attributes.type),
        borderColor: this.getBackgroundColour(element.attributes.type),
      };
      graphDataSets.push(graphDataSet);
    }

    this.graph = new Chart('graph1', {
      type: 'line',
      data: {
        datasets: graphDataSets,
      },
      options: {
        plugins: {
          zoom: {
            limits: {},
            zoom: {
              drag: {
                enabled: true

              },
              mode: 'x',

            }
          }
        },
        scales: {
          movement: {
            type: 'linear',
            position: 'left',
            max: 1.1,
            min: 0,
            ticks: {
              stepSize: 1,
              autoSkip: true,
              callback: (value, index, values) => {
                if (index === values.length - 1) {
                  return '';
                }
                return value === 1 ? 'Motion' : 'No Motion';
              }
            }
          },
          lightLevel: {
            type: 'linear',
            position: 'right',
            ticks: {
              callback: (value, index, values) => {
                return value + '%';
              }
            }
          },
          x: {
            type: 'time',
            adapters: {
              date: {
                locale: enUS
              },

            },
            time: {
              unit: 'day',
            }
          },
        },
        maintainAspectRatio: false,

      }
    });
  }

}

export const motionDataProcess = function (data, features) {
  for (let index = 0; index < data.length; index++) {
    let dataSet = data[index];
    if (!dataSet) {
      continue;
    }

    let feature = features[index];

    if (feature.attributes.type === 'batteryLevel') {
      delete features[index];
      delete data[index];
      continue;
    }

    if (feature.attributes.type === 'lightLevel') {
      addLastValue(dataSet);
    }

    let lastDataIndex = 0;


    let newData = [];

    if (feature.attributes.type === 'movement') {
      for (let i = 0; i < dataSet.length; i++) {
        if (lastDataIndex === 0) {
          newData.push(dataSet[i]);
          lastDataIndex = i;
          continue;
        }

        if (dataSet[i].value === dataSet[lastDataIndex].value) {
          lastDataIndex = i;
          continue;
        }
        newData.push(dataSet[i]);
        lastDataIndex = i;
      }
    }

    dataSet[index] = newData;

  }
};

export const heatingDataProcess = function (data: TimeSeriesData[], features) {
  for (let index = 0; index < features.length; index++) {
    let feature = features[index];
    if (feature.attributes.type === 'batteryLevel') {
      delete features[index];
      delete data[index];
      continue;
    }
    addLastValue(data[index]);
  }
};

export const compareFunc = function (a, b) {
  if (a.timestamp < b.timestamp) {
    return 1;
  }
  if (a.timestamp > b.timestamp) {
    return -1;
  }
  // a must be equal to b
  return 0;
};

/** add an end value for output */
export let addLastValue = (data) => {
  if (!data.length) {
    return data = [{
      timestamp: Date.now(),
      value: 0
    }, {
      timestamp: Date.now() - time.week,
      value: 0
    }];

  }
};
